import { FC, useState } from 'react'

import { useTranslation } from 'react-i18next'

import { Button } from 'shared/ui/button'
import { InputWithLabel } from 'shared/ui/input-label'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface Props {
  onCreate: (label: string) => void
  onClose?: () => void
}

export const AddCloseCircleForm: FC<Props> = ({ onCreate, onClose }) => {
  const { t } = useTranslation()

  const [label, setLabel] = useState<string>('')
  const normalizedLabel = label.trim()

  return (
    <Paper padding={[8, 0, 16, 0]}>
      <div className={s.container}>
        <h3>{t('сlose_circlу')}</h3>

        <p>{t('close_circle.add_description')}</p>

        <div className={s.input}>
          <InputWithLabel
            label={t('close_circle.save_as')}
            onChange={(e) => setLabel(e.currentTarget?.value || '')}
          />
        </div>

        <Button
          disabled={!normalizedLabel}
          onClick={() => onCreate(normalizedLabel)}
        >
          <span className={s.add}>{t('add')}</span>
        </Button>
        <Button
          variant="transparent"
          onClick={onClose}
        >
          <span className={s.close}>{t('close')}</span>
        </Button>
      </div>
    </Paper>
  )
}
